import { Application } from 'stimulus';
import { definitionsFromContext } from 'stimulus/webpack-helpers';

import 'modernizr'; // eslint-disable-line
import './bootstrap';
import './vendor/bootstrap';
import toArray from './helpers/toArray';

import sentry from './sentry';

sentry();

const application = Application.start();
const context = require.context('./controllers', true, /\.js$/);
application.load(definitionsFromContext(context));

const collapsibleEls = toArray(document.querySelectorAll('.collapse'));

if (collapsibleEls.length) {
  collapsibleEls.forEach((element) => {
    const collapseButton = document.querySelector(`[data-target="#${element.id}"]`);
    const span = collapseButton?.querySelector('span');
    const changeText = collapseButton?.getAttribute('data-change-text') === 'true';

    if (!collapseButton || !span || !changeText) return;

    $(element).on('show.bs.collapse', () => { span.innerText = 'Minder tonen'; });
    $(element).on('hide.bs.collapse', () => { span.innerText = 'Meer tonen'; });
  });
}

$(() => {
  $('[data-toggle="tooltip"]').tooltip();
});

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(() => {
        // Registration was successful
      })
      .catch((err) => {
        console.log('ServiceWorker registration failed: ', err); // eslint-disable-line
      });
  });
}
